import { render, staticRenderFns } from "./AwardsPage.vue?vue&type=template&id=15223f68&scoped=true&"
import script from "./AwardsPage.vue?vue&type=script&lang=js&"
export * from "./AwardsPage.vue?vue&type=script&lang=js&"
import style0 from "./AwardsPage.vue?vue&type=style&index=0&id=15223f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15223f68",
  null
  
)

/* custom blocks */
import block0 from "./AwardsPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports